(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const track = (event, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, mark: '12', ...detail });
  };

  const setupHero = () => {
    const dataNode = document.getElementById('GiftyMark11Products');
    const visual = document.querySelector('.gfy-hero__visual');
    if (!dataNode || !visual || visual.dataset.gx12Ready === 'true') return;

    let products = [];
    try {
      products = JSON.parse(dataNode.textContent)
        .filter((item) => item?.image && item?.url && item?.available !== false)
        .slice(0, 12);
    } catch (_) {
      return;
    }
    if (products.length < 2) return;

    visual.dataset.gx12Ready = 'true';
    visual.classList.add('is-gx12-showcase');
    visual.querySelectorAll(':scope > .gfy-product-shot, :scope > .gfy-rating-card, :scope > .gfy-visual__backdrop').forEach((node) => {
      node.setAttribute('aria-hidden', 'true');
      if (node.matches('a,button')) node.setAttribute('tabindex', '-1');
      node.querySelectorAll('a,button').forEach((control) => control.setAttribute('tabindex', '-1'));
    });

    const root = document.createElement('div');
    root.className = 'gx12-showcase';
    root.setAttribute('role', 'region');
    root.setAttribute('aria-label', 'Automatically rotating featured Gifty products');

    const aura = document.createElement('span');
    aura.className = 'gx12-showcase__aura';
    aura.setAttribute('aria-hidden', 'true');

    const main = document.createElement('a');
    main.className = 'gx12-showcase__main';
    const imageOne = document.createElement('img');
    const imageTwo = document.createElement('img');
    [imageOne, imageTwo].forEach((image, imageIndex) => {
      image.className = `gx12-showcase__image${imageIndex === 0 ? ' is-active' : ''}`;
      image.alt = '';
      image.decoding = 'async';
      image.fetchPriority = imageIndex === 0 ? 'high' : 'auto';
    });

    const meta = document.createElement('span');
    meta.className = 'gx12-showcase__meta';
    const eyebrow = document.createElement('small');
    eyebrow.textContent = 'Live from the Gifty catalogue';
    const title = document.createElement('strong');
    const price = document.createElement('span');
    meta.append(eyebrow, title, price);
    main.append(imageOne, imageTwo, meta);

    const productIndex = document.createElement('span');
    productIndex.className = 'gx12-showcase__index';
    productIndex.setAttribute('aria-hidden', 'true');
    const progress = document.createElement('span');
    progress.className = 'gx12-showcase__progress';
    progress.setAttribute('aria-hidden', 'true');
    progress.append(document.createElement('i'));
    const pause = document.createElement('button');
    pause.className = 'gx12-showcase__pause';
    pause.type = 'button';
    pause.textContent = reduceMotion ? '▶' : 'Ⅱ';
    pause.setAttribute('aria-label', reduceMotion ? 'Play product rotation' : 'Pause product rotation');
    pause.setAttribute('aria-pressed', String(reduceMotion));

    const stamp = document.createElement('span');
    stamp.className = 'gx12-showcase__stamp';
    stamp.setAttribute('aria-hidden', 'true');
    stamp.innerHTML = '<b>LIVE</b><span>fresh ideas<br>on rotation</span>';

    root.append(aura, main, productIndex, progress, pause, stamp);
    visual.append(root);

    let index = 0;
    let activeImage = imageOne;
    let timer = null;
    let paused = reduceMotion;
    let transitionToken = 0;
    const duration = 4600;
    root.style.setProperty('--gx12-duration', `${duration}ms`);
    const normalize = (value) => (value + products.length) % products.length;

    const preload = (value) => {
      const preloaded = new Image();
      preloaded.src = products[normalize(value)].image;
    };
    const restartProgress = () => {
      root.classList.remove('is-counting');
      void progress.offsetWidth;
      if (!paused) root.classList.add('is-counting');
    };
    const schedule = () => {
      window.clearTimeout(timer);
      if (!paused && !document.hidden) timer = window.setTimeout(() => show(index + 1), duration);
    };
    const updatePause = () => {
      pause.textContent = paused ? '▶' : 'Ⅱ';
      pause.setAttribute('aria-label', paused ? 'Play product rotation' : 'Pause product rotation');
      pause.setAttribute('aria-pressed', String(paused));
      root.classList.toggle('is-paused', paused);
      restartProgress();
    };

    const commit = async (target, token) => {
      const item = products[target];
      const incoming = activeImage === imageOne ? imageTwo : imageOne;
      incoming.src = item.image;
      incoming.alt = item.title;
      try { await incoming.decode(); } catch (_) { /* The load event can still paint the image. */ }
      if (token !== transitionToken) return;

      root.classList.add('is-transitioning');
      incoming.classList.add('is-active');
      activeImage.classList.remove('is-active');
      activeImage = incoming;
      index = target;
      main.href = item.url;
      main.setAttribute('aria-label', `${item.title}. Bulk from ${item.bulkPrice} each; single from ${item.price}. View product.`);
      title.textContent = item.title;
      price.textContent = `Bulk from ${item.bulkPrice} each · single from ${item.price}`;
      productIndex.textContent = `${String(index + 1).padStart(2, '0')} / ${String(products.length).padStart(2, '0')}`;
      root.style.setProperty('--gx12-accent-shift', `${(index * 29) % 180}deg`);
      window.setTimeout(() => root.classList.remove('is-transitioning'), 760);
      preload(index + 1);
      restartProgress();
      schedule();
    };
    const show = (nextIndex) => {
      const target = normalize(nextIndex);
      transitionToken += 1;
      commit(target, transitionToken);
    };

    pause.addEventListener('click', () => {
      paused = !paused;
      updatePause();
      schedule();
      track('homepage_showcase_pause', { paused });
    });
    main.addEventListener('click', () => track('homepage_showcase_product_click', { product_title: products[index].title }));
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) window.clearTimeout(timer);
      else schedule();
    });

    updatePause();
    show(0);
  };

  const setupContextualIntelligence = () => {
    const assistant = document.querySelector('[data-gx91-ai]');
    if (!assistant) return;
    const h1 = document.querySelector('main h1')?.textContent?.trim();
    const promptButtons = [...assistant.querySelectorAll('[data-gx91-prompt]')];
    const isProduct = document.body.classList.contains('template-product') || /\/products\//.test(location.pathname);
    const isCollection = document.body.classList.contains('template-collection') || /\/collections\//.test(location.pathname);
    if (isProduct && h1 && promptButtons.length >= 2) {
      promptButtons[0].textContent = 'Is this right for my order?';
      promptButtons[0].dataset.gx91Prompt = `Help me evaluate ${h1} for a corporate order. Ask me quantity and budget if needed.`;
      promptButtons[1].textContent = 'Logo + production advice';
      promptButtons[1].dataset.gx91Prompt = `How should I customize ${h1}, and what must be confirmed before production?`;
    } else if (isCollection && h1 && promptButtons.length >= 2) {
      promptButtons[0].textContent = 'Shortlist this collection';
      promptButtons[0].dataset.gx91Prompt = `Help me shortlist products from ${h1} for my quantity and budget.`;
      promptButtons[1].textContent = 'Compare best options';
      promptButtons[1].dataset.gx91Prompt = `Compare the strongest scalable options related to ${h1}.`;
    }
    const input = assistant.querySelector('[data-gx91-input]');
    if (input && h1) input.placeholder = isProduct ? `Ask about ${h1.slice(0, 42)}…` : input.placeholder;
  };

  const setupCommerceMotion = () => {
    document.documentElement.classList.add('gx12-ready');
    document.querySelectorAll('.card-wrapper, .gfy-product-card').forEach((card, index) => {
      card.classList.add('gx12-product-card');
      card.style.setProperty('--gx12-card-order', String(index % 8));
    });

    document.addEventListener('click', (event) => {
      const addButton = event.target.closest('form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] button[type="submit"]');
      if (!addButton || addButton.disabled) return;
      addButton.classList.add('gx12-is-adding');
      window.setTimeout(() => addButton.classList.remove('gx12-is-adding'), 1050);
    }, true);

    let cartFrame = 0;
    const animateCart = () => {
      cartFrame = 0;
      const drawer = document.querySelector('cart-drawer, #CartDrawer');
      if (!drawer) return;
      drawer.querySelector('.drawer__inner')?.classList.add('gx12-cart-surface');
      drawer.querySelectorAll('.cart-item').forEach((item, index) => {
        item.classList.add('gx12-cart-item');
        item.style.setProperty('--gx12-cart-order', String(index));
      });
      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        bubble.classList.remove('gx12-cart-pulse');
        void bubble.offsetWidth;
        bubble.classList.add('gx12-cart-pulse');
      });
      const emptyCart = drawer.querySelector('.drawer__inner-empty, .cart__empty-text')?.closest('.drawer__inner-empty, .cart__warnings, .drawer__inner');
      if (emptyCart && !emptyCart.querySelector('[data-gx12-empty-cart]') && !drawer.querySelector('.cart-item')) {
        const recovery = document.createElement('nav');
        recovery.className = 'gx12-empty-cart';
        recovery.dataset.gx12EmptyCart = 'true';
        recovery.setAttribute('aria-label', 'Continue gift shopping');
        recovery.innerHTML = '<strong>Find the right next step</strong><a href="/collections/new-arrivals">Explore new arrivals</a><a href="/pages/gift-finder">Open Gift Finder</a><button type="button" data-gx12-open-ai>Ask Gifty AI</button>';
        emptyCart.append(recovery);
        recovery.querySelector('[data-gx12-open-ai]')?.addEventListener('click', () => {
          drawer.querySelector('button[aria-label*="Close"], .drawer__close')?.click();
          window.setTimeout(() => document.querySelector('[data-gx91-open]')?.click(), 180);
        });
      }
    };
    const observer = new MutationObserver(() => {
      if (cartFrame) return;
      cartFrame = requestAnimationFrame(animateCart);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    animateCart();
  };

  const setupPurchasePath = () => {
        // Keep quote-first concept pages clear: Shopify's default retail price and
            // shipping copy can still render even when immediate checkout is unavailable.
                const isSpecialOrder = Boolean(document.querySelector('[data-gifty-concept-pricing]'));
    if (isSpecialOrder) {
      document.documentElement.classList.add('gx15-special-order');
      document.querySelectorAll('[data-gxc-open], [data-gxc-media-open]').forEach((trigger) => {
        const detail = trigger.querySelector('small, .gx10-customize-chip__copy small');
        if (detail) detail.textContent = 'Send your brief for a confirmed quote';
      });
      return;
    }
    const pricing = document.querySelector('[data-gifty-volume-pricing]');
    const table = pricing?.querySelector('.gvp__table');
    if (pricing && table && !pricing.querySelector('[data-gx12-pricing-details]')) {
      pricing.classList.add('gx12-pricing-compact');
      const details = document.createElement('details');
      details.className = 'gx12-pricing-details';
      details.dataset.gx12PricingDetails = 'true';
      const summary = document.createElement('summary');
      summary.innerHTML = '<span>View all quantity price tiers</span><small>1–9, 10+, 25+, 50+, 100+ and 250+ quote</small>';
      details.append(summary, table);
      const calculator = pricing.querySelector('.gvp__calculator');
      pricing.insertBefore(details, calculator || pricing.lastElementChild);
    }

    if (!/\/products\//.test(location.pathname) || document.querySelector('[data-gx12-buy-rail]')) return;
    const actualAdd = document.querySelector('product-form button[name="add"], product-form button[type="submit"], form[action*="/cart/add"] button[name="add"]');
    if (!actualAdd) return;
    const title = document.querySelector('main h1')?.textContent?.trim() || 'Selected product';
    const price = document.querySelector('.price .price-item:not(.price-item--sale), .price .price-item--regular')?.textContent?.trim() || '';
    const rail = document.createElement('aside');
    rail.className = 'gx12-buy-rail';
    rail.dataset.gx12BuyRail = 'true';
    rail.setAttribute('aria-label', 'Quick product actions');
    rail.innerHTML = `<span><small>Ready when you are</small><strong>${title.replace(/[&<>"']/g, '')}</strong>${price ? `<em>${price.replace(/[&<>"']/g, '')}</em>` : ''}</span><button type="button" data-gx12-rail-customize>Customize</button><button type="button" data-gx12-rail-buy>View options & buy</button>`;
    document.body.append(rail);
    rail.querySelector('[data-gx12-rail-customize]')?.addEventListener('click', () => document.querySelector('[data-gxc-open]')?.click());
    rail.querySelector('[data-gx12-rail-buy]')?.addEventListener('click', () => {
      const target = actualAdd.closest('.product-form__buttons, product-form, form') || actualAdd;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      window.setTimeout(() => actualAdd.focus(), reduceMotion ? 0 : 450);
      track('sticky_buy_rail_click', { item_name: title });
    });
    if ('IntersectionObserver' in window) {
      const buyObserver = new IntersectionObserver(([entry]) => rail.classList.toggle('is-hidden', entry.isIntersecting), { threshold: .45 });
      buyObserver.observe(actualAdd);
    }
  };

  const setupGalleryCustomizer = () => {
    if (!/\/products\//.test(location.pathname) || document.querySelector('[data-gx15-gallery-customize], [data-gxc-media-open]')) return;
    const launch = document.querySelector('[data-gxc-open]');
    const gallery = document.querySelector('[id^="MediaGallery"], .product__media-list, .product__media-wrapper, .product-media-container');
    if (!launch || !gallery) return;

    const target = gallery.querySelector('.product__media-wrapper, .product__media, .product-media-container') || gallery;
    target.classList.add('gx15-product-media');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'gx15-gallery-customize';
    button.dataset.gx15GalleryCustomize = 'true';
    button.setAttribute('aria-label', `Open Design Studio for ${document.querySelector('main h1')?.textContent?.trim() || 'this product'}`);
    button.innerHTML = '<span aria-hidden="true">✦</span><strong>Customize with your logo</strong><small>Preview before you request a proof</small>';
    button.addEventListener('click', () => {
      launch.click();
      track('product_gallery_customizer_open', { item_name: document.querySelector('main h1')?.textContent?.trim() || '' });
    });
    target.append(button);
  };

  const setupCollisionSafety = () => {
    const assistant = document.querySelector('[data-gx91-ai]');
    if (!assistant) return;
    const launcher = assistant.querySelector('[data-gx91-open]');
    let frame = 0;
    const check = () => {
      frame = 0;
      if (assistant.classList.contains('is-open') || !launcher?.getClientRects().length) { assistant.classList.remove('gx12-yield'); return; }
      const launcherRect = launcher.getBoundingClientRect();
      const blockingOverlay = [...document.querySelectorAll('[aria-modal="true"], [role="dialog"]')].some((overlay) => {
        if (assistant.contains(overlay)) return false;
        const style = window.getComputedStyle(overlay);
        const rect = overlay.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) > .05 &&
          rect.width > 10 && rect.height > 10 && rect.right > 0 && rect.bottom > 0 &&
          rect.left < window.innerWidth && rect.top < window.innerHeight;
      });
      if (blockingOverlay) { assistant.classList.add('gx12-yield'); return; }
      const targets = document.querySelectorAll('form[action*="contact"] button[type="submit"], .product-form__submit:not([disabled]), .shopify-payment-button__button, .mobile-facets__footer button, .gxc__footer button:not([disabled])');
      const overlap = [...targets].some((target) => {
        if (!target.getClientRects().length) return false;
        const rect = target.getBoundingClientRect();
        return rect.left < launcherRect.right && rect.right > launcherRect.left && rect.top < launcherRect.bottom && rect.bottom > launcherRect.top;
      });
      assistant.classList.toggle('gx12-yield', overlap);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(check); };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden', 'open']
    });
    check();
  };

  const setupAccessibilityRepairs = () => {
    document.querySelectorAll('.mobile-facets__close').forEach((close) => {
      close.setAttribute('role', 'button');
      close.setAttribute('aria-label', 'Close filters');
      if (!close.hasAttribute('tabindex')) close.tabIndex = 0;
      close.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); close.click(); }
      });
    });
  };

  const start = () => {
    setupHero();
    setupContextualIntelligence();
    setupCommerceMotion();
    setupPurchasePath();
    setupGalleryCustomizer();
    setupCollisionSafety();
    setupAccessibilityRepairs();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
